import L from "leaflet";

const SAFETY_COLOR = {
    favorable: "#16a34a",
    caution: "#eab308",
    dangerous: "#dc2626",
    offline: "#475569",
    unknown: "#64748b",
};

// Maps the 4-tier output of getFlightSafetyStatus() to the 5-tier marker palette.
// `neutral` collapses to `caution` so the marker still tints (rather than
// reading as a generic gray pin) when the station reports wind but the
// direction doesn't match the site's `suitableWindDirections`.
export const mapFlightStatusToSafety = (status) => {
    switch (status) {
        case "good": return "favorable";
        case "danger": return "dangerous";
        case "offline": return "offline";
        case "neutral": return "caution";
        default: return "unknown";
    }
};

const haloLayer = () =>
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style="position:absolute;inset:0;width:100%;height:100%" aria-hidden="true">` +
    `<circle cx="32" cy="32" r="22" fill="white" stroke="currentColor" stroke-width="2.5"/></svg>`;

// PNG silhouette tinted via SVG feFlood + feComposite "in" — keeps only pixels
// where the source PNG has non-zero alpha, painting them with floodColor.
const paragliderLayer = (safety, floodColor) => {
    const filterId = `pgtint-${safety}`;
    return (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style="position:absolute;inset:0;width:100%;height:100%" aria-hidden="true">` +
        `<defs><filter id="${filterId}" x="0" y="0" width="100%" height="100%">` +
        `<feFlood flood-color="${floodColor}"/>` +
        `<feComposite in2="SourceGraphic" operator="in"/>` +
        `</filter></defs>` +
        `<image href="/assets/images/paraglider.png" x="18" y="18" width="28" height="28" filter="url(#${filterId})"/>` +
        `</svg>`
    );
};

// Chevron sitting just above the halo at 0° rotation. Rotation = direction + 180
// so the arrow points DOWNWIND (the direction wind is going) — wind direction
// is reported as the direction it comes FROM.
const arrowGlyph =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style="position:absolute;inset:0;width:100%;height:100%;overflow:visible" aria-hidden="true">` +
    `<path d="M32 -2 L46 16 L18 16 Z" fill="currentColor" stroke="white" stroke-width="3" stroke-linejoin="miter" stroke-miterlimit="10" paint-order="stroke fill"/>` +
    `</svg>`;

export const makeWindMarkerIcon = (directionDeg, safety = "unknown") => {
    const color = SAFETY_COLOR[safety] || SAFETY_COLOR.unknown;
    const hasDirection = directionDeg != null && !Number.isNaN(Number(directionDeg));
    const rotation = hasDirection ? Number(directionDeg) + 180 : 0;

    const arrowLayer = hasDirection
        ? `<div style="position:absolute;inset:0;transform:rotate(${rotation}deg);z-index:10;">${arrowGlyph}</div>`
        : "";

    const html =
        `<div style="position:relative;width:52px;height:52px;color:${color};filter:drop-shadow(0 1px 3px rgba(0,0,0,0.55));">` +
        `${haloLayer()}${paragliderLayer(safety, color)}${arrowLayer}` +
        `</div>`;

    return L.divIcon({
        className: "wind-marker",
        html,
        iconSize: [52, 52],
        iconAnchor: [26, 26],
    });
};
